export enum NursingAllowanceStateEnum {
    OPEN = 'OTV',
    IN_PROGRESS = 'RZP',
    CLOSED = 'UKC',
    CANCELLED = 'STR',
    NEW = 'NEW', // Local state until ČSSZ returns the case detail.
}
